/**
 * Created by kierangrosvenor on 25/05/2017.
 */

/**
 * Created by Kieran on 18/05/2017.
 */

import axios from 'axios'
import config from '../../config'

let DiscussionApi = {
  CancelToken: axios.CancelToken,
  CancelRequests: null,
  deleteAnswer(answer_id) {
    return axios.delete(config.apiUrl + 'discussion/thread/reply/' + answer_id)
  },
  updateAnswer(model) {
    return axios.put(config.apiUrl + 'discussion/thread/reply/', model)
  },
  updateQuestion(model) {
    return axios.put(config.apiUrl + 'discussion/thread/', model);
  },
  deleteQuestion(question_id) {
    return axios.delete(config.apiUrl + 'discussion/thread/' + question_id);
  },
  hideQuestion(question_id) {
    let model = {
      question_id: question_id
    }
    return axios.post(config.apiUrl + 'discussion/thread/hide/', model);
  },
  likeDiscussionQuestion(question_id) {
    let model = {
      question_id: question_id
    };
    return axios.post(config.apiUrl + 'discussion/thread/like/', model)
  },
  likeDiscussionReply(answer_id) {
    let model = {
      answer_id: answer_id
    };
    return axios.post(config.apiUrl + 'discussion/thread/reply/like/', model);
  },
  postDiscussionReply(model) {
    return axios.post(config.apiUrl + 'discussion/thread/reply/', model)
  },
  getDiscussionFrequentlyAsked() {
    return axios.get(config.apiUrl + 'discussion/frequently-asked/');
  },
  getDiscusionRecentlyAsked(user_id) {
    return axios.get(config.apiUrl + 'discussion/recently-asked/' + user_id)
  },
  getDiscussionsTopContributors() {
    return axios.get(config.apiUrl + 'discussion/top-contributors/5')
  },
  getDiscussionThread(id, model) {
    let self = this;
    return axios.get(config.apiUrl + 'discussion/thread/' + id + '?' + this.serialize((model)))
  },
  createDiscussionThread(model) {
    return axios.post(config.apiUrl + 'discussion/thread/', model);
  },
  getDiscussionQuestions(model) {
    let self = this;
    return axios.get(config.apiUrl + 'discussion/items?' + this.serialize(model), {
      cancelToken: new self.CancelToken(function executor(c) {
        // An executor function receives a cancel function as a parameter
        self.CancelRequests = c;
      })
    })
  },
  serialize(obj) {
    var str = [];
    for (var p in obj)
      if (obj.hasOwnProperty(p)) {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    return str.join("&");
  }
};

export default DiscussionApi;




// WEBPACK FOOTER //
// ./src/api/Discussion/index.js